<template>
  <div>
    <BasePage
      :title="`${route.meta.title}`"
      :subtitle="`Manage ${route.meta.title}`"
      :truncateTitle="false"
    >
      <template #page-header:actions>
        <div class="d-flex flex-column flex-sm-row w-100">
          <v-btn
            color="primary"
            depressed
            @click="open"
            class="mb-2 mb-sm-0 mr-sm-2"
            :loading="isLoading"
            v-if="currentUser?.hasPermission('cctv_reports.add_cctvreport')"
          >
            <v-icon left class="hidden-sm-and-down mr-1"> {{ route.meta.icon }} </v-icon>
            Create Report
          </v-btn>

          <v-btn
            v-if="
              currentUser?.hasPermission('cctv_reports.approve_cctvreport') ||
              currentUser?.hasPermission('guard_reports.approve_guardreport') ||
              currentUser?.hasPermission('incident_reports.approve_incidentreport')
            "
            color="secondary"
            :loading="isLoading"
            :disabled="!reportHasBeenSelected"
            depressed
            @click="sendReports"
          >
            <v-icon left class="hidden-sm-and-down mr-1">mdi-share </v-icon>
            Share Reports
          </v-btn>
        </div>
      </template>

      <template #page-header:bottom>
        <ErrorAlert
          dense
          v-if="error != null"
          :error="error"
          @clearErrors="clearErrors"
          class="mb-0 mt-4 rounded"
        />
      </template>

      <v-card flat class="px-4 rounded-lg rounded-b-0">
        <v-toolbar flat height="84" color="transparent">
          <slot name="search"></slot>
        </v-toolbar>
      </v-card>
      <v-card flat height="calc(100vh - 370px)" class="px-4 rounded-lg rounded-t-0">
        <slot name="content"></slot>
      </v-card>
    </BasePage>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

import BasePage from '@/components/base/BasePage.vue'
import ErrorAlert from '@/components/common/ErrorAlert.vue'
import { computed, type PropType } from 'vue'
import type { IGuardReport, ICCTVReport, IIncidentReport } from '@/models/report'

const route = useRoute()
const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
const emit = defineEmits(['openDialog', 'sendReports'])

const error = defineModel<Error | null>('error', {
  default: null
})

const props = defineProps({
  selectedReports: {
    type: Array as PropType<IGuardReport[] | ICCTVReport[] | IIncidentReport[]>,
    required: true,
    default: () => []
  },
  isLoading: {
    type: Boolean,
    default: false
  }
})

const reportHasBeenSelected = computed(() => props.selectedReports.length > 0)

const clearErrors = () => {
  error.value = null
}

const open = () => {
  emit('openDialog')
}

function sendReports() {
  emit('sendReports')
}
</script>
